import type { SvgIconProps } from '@/components/SvgIcon/SvgIcon';

import { SvgIcon } from '@/components/SvgIcon';
import { cn } from '@/lib/utils';

export const AppLogo = (props: Omit<SvgIconProps, 'name'>) => {
  return (
    <SvgIcon
      aria-label="Pindrop logo"
      className={cn('text-deep-blue', props.className)}
      name="pindrop-logo"
      role="img"
      {...props}
    />
  );
};
